import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

export const SummaryMetricCard = ({ icon, title, value, suffix, helper }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        minHeight: 85,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center', width: '100%', minWidth: 0 }}>
        <Box
          sx={{
            width: 46,
            height: 46,
            borderRadius: 1.5,
            bgcolor: 'primary.container',
            color: 'primary.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: '0 0 auto',
          }}
        >
          {icon}
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 14, fontWeight: 700, color: 'text.secondary' }}>
            {title}
          </Typography>
          <Typography sx={{ fontSize: 26, fontWeight: 700, lineHeight: '32px' }}>
            {value} <Typography component="span" sx={{ fontSize: 14, color: 'text.secondary' }}>{suffix}</Typography>
          </Typography>
          {/* {helper && (
            <Typography sx={{ fontSize: 13, color: 'text.secondary', mt: 0.25 }}>
              {helper}
            </Typography>
          )} */}
        </Box>
      </Stack>
    </Paper>
  );
};
